export default __webpack_public_path__ + "static/langchain-39da3a5191fbfab0e7776d378c23b2aa.png";